var _g, _path, _circle, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgValveUnknown = function SvgValveUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#valve-unknown_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 19,
    r: 16,
    fill: "#F1F4F4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 19,
    r: 15,
    stroke: "#4A7E04",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 17.286 14 13v12l8-4.286L30 25V13l-8 4.286Z",
    fill: "#4A7E04"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 8,
    r: 6.125,
    fill: "#4A7E04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.133 9.492c0-.52.064-.933.193-1.242.13-.309.383-.646.762-1.014.383-.37.625-.634.727-.79.156-.239.234-.497.234-.774 0-.367-.092-.647-.276-.838-.18-.195-.445-.293-.796-.293-.336 0-.608.096-.815.287-.203.188-.305.443-.305.768h-1.423c.007-.692.242-1.239.703-1.64.465-.403 1.078-.604 1.84-.604.785 0 1.396.199 1.834.597.441.399.662.955.662 1.67 0 .637-.297 1.264-.891 1.881l-.72.709c-.259.293-.391.72-.4 1.283h-1.33Zm-.1 1.822c0-.23.072-.416.217-.556.145-.145.34-.217.586-.217.25 0 .447.074.592.223a.746.746 0 0 1 .217.55c0 .215-.07.395-.211.54-.141.144-.34.216-.598.216-.258 0-.457-.072-.598-.216a.754.754 0 0 1-.205-.54Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "valve-unknown_svg__a",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow",
    result: "effect3_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow",
    result: "shape"
  })))));
};
export { SvgValveUnknown as ReactComponent };
export default "data:image/svg+xml,%3csvg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg filter='url(%23filter0_ddd)'%3e %3ccircle cx='22' cy='19' r='16' fill='%23F1F4F4'/%3e %3ccircle cx='22' cy='19' r='15' stroke='%234A7E04' stroke-width='2'/%3e %3c/g%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M22 17.2857L14 13L14 25L22 20.7143L30 25L30 13L22 17.2857Z' fill='%234A7E04'/%3e %3ccircle cx='35' cy='8' r='6.125' fill='%234A7E04'/%3e %3cpath d='M34.1328 9.49219C34.1328 8.97266 34.1973 8.55859 34.3262 8.25C34.4551 7.94141 34.709 7.60352 35.0879 7.23633C35.4707 6.86523 35.7129 6.60156 35.8145 6.44531C35.9707 6.20703 36.0488 5.94922 36.0488 5.67188C36.0488 5.30469 35.957 5.02539 35.7734 4.83398C35.5938 4.63867 35.3281 4.54102 34.9766 4.54102C34.6406 4.54102 34.3691 4.63672 34.1621 4.82812C33.959 5.01562 33.8574 5.27148 33.8574 5.5957H32.4336C32.4414 4.9043 32.6758 4.35742 33.1367 3.95508C33.6016 3.55273 34.2148 3.35156 34.9766 3.35156C35.7617 3.35156 36.373 3.55078 36.8105 3.94922C37.252 4.34766 37.4727 4.9043 37.4727 5.61914C37.4727 6.25586 37.1758 6.88281 36.582 7.5L35.8613 8.20898C35.6035 8.50195 35.4707 8.92969 35.4629 9.49219H34.1328ZM34.0332 11.3145C34.0332 11.084 34.1055 10.8984 34.25 10.7578C34.3945 10.6133 34.5898 10.541 34.8359 10.541C35.0859 10.541 35.2832 10.6152 35.4277 10.7637C35.5723 10.9082 35.6445 11.0918 35.6445 11.3145C35.6445 11.5293 35.5742 11.709 35.4336 11.8535C35.293 11.998 35.0938 12.0703 34.8359 12.0703C34.5781 12.0703 34.3789 11.998 34.2383 11.8535C34.1016 11.709 34.0332 11.5293 34.0332 11.3145Z' fill='white'/%3e %3cdefs%3e %3cfilter id='filter0_ddd' x='0' y='0' width='44' height='44' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3e %3cfeFlood flood-opacity='0' result='BackgroundImageFix'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='3'/%3e %3cfeGaussianBlur stdDeviation='3'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0'/%3e %3cfeBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='2'/%3e %3cfeGaussianBlur stdDeviation='2'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'/%3e %3cfeBlend mode='normal' in2='effect1_dropShadow' result='effect2_dropShadow'/%3e %3cfeColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'/%3e %3cfeOffset dy='2'/%3e %3cfeGaussianBlur stdDeviation='2'/%3e %3cfeColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0'/%3e %3cfeBlend mode='normal' in2='effect2_dropShadow' result='effect3_dropShadow'/%3e %3cfeBlend mode='normal' in='SourceGraphic' in2='effect3_dropShadow' result='shape'/%3e %3c/filter%3e %3c/defs%3e %3c/svg%3e";